import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How do I find the best mobile app developer company?",
    answer: `<p>Here are the 5 top considerations when picking the best mobile app developer:</p> 
        <ul>
        <li>Qualification and Experience</li>
        <li>References and Portfolio</li>
        <li>App Development Cost</li>
        <li>Communication Process</li>
        <li>Client Focus</li>
    </ul>`,
  },
  {
    question: "How much money do you need to build an app?",
    answer: `   <p>There are many factors that influence the cost of an app. However, the main factor is the complexity of your app.</p>
        <p>Considering $40 per hour as the development cost, a simple app can cost you around $40,000 to $60,000. Similarly, the cost of building an average app can be around $60,000 to $150,000. And lastly, if you’re building a complex app with intricate features then the cost for developing such an app can start from $300,000.</p>`,
  },
  {
    question: "What is the average profit of an app?",
    answer: `<p>On average, a mobile app with 1 million users can generate around $10,000 per day.</p>`,
  },
  {
    question: "How much does it cost to pay a company to build an app?",
    answer: `<p>The cost to create a mobile application is between $30,000 and $250,000, with an average cost of $171,450, according to the latest industry reports.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
